import React, { forwardRef, createContext, useContext, useState, useEffect } from 'react';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';

const SpeechToTextContext = createContext();


export const SpeechToTextProvider = ({ children }) => {

  const [translation, setTranslation] = useState();
  const {
    transcript,
    listening,
    interimTranscript,
    finalTranscript,
    resetTranscript,
    startListening,
    stopListening,
  } = useSpeechRecognition();




  useEffect(() => {
    if (finalTranscript !== '') {
      console.log('Got final result:', finalTranscript);

      /*
      const chatWorlds = ['gioia','Gioia','chiami','tuo nome'];

      const containsElement = some(chatWorlds, element => finalTranscript.includes(element));
      */
      const containsElement = true;
      if (containsElement) {
        setTranslation(finalTranscript);
      }
      console.log({ finalTranscript });
      resetTranscript();

    }
  }, [interimTranscript, finalTranscript]);




  const startCaptioning = () => {
    SpeechRecognition.startListening({ continuous: true, language: 'it-IT' });
  }



  const startStopListening = () => {
    if (listening) {
      SpeechRecognition.stopListening();
    } else {
      SpeechRecognition.startListening({ continuous: true, language: 'it-IT' });
    }
  }

  const blockListening = () => {
    SpeechRecognition.stopListening();
  }


  return (
    <SpeechToTextContext.Provider
      value={{
        startCaptioning, startStopListening, blockListening, translation
      }}
    >
      {children}
    </SpeechToTextContext.Provider>
  );


};


export const useSpeechToText = () => {
  const context = useContext(SpeechToTextContext);
  if (!context) {
    throw new Error("useSpeechToText must be used within a SpeechToTextProvider");
  }
  return context;
};